import { apiClient } from '@/lib/axios';
import { WorkspaceListResponseSchema, WorkspaceResponseSchema, } from '@/features/workspaces/types';
export async function getWorkspaces() {
    const response = await apiClient.get('/api/v1/workspaces');
    return WorkspaceListResponseSchema.parse(response.data);
}
export async function createWorkspace(name) {
    const response = await apiClient.post('/api/v1/workspaces', { name });
    return WorkspaceResponseSchema.parse(response.data).data;
}
export async function updateWorkspace(id, name) {
    const response = await apiClient.put(`/api/v1/workspaces/${id}`, { name });
    return WorkspaceResponseSchema.parse(response.data).data;
}
